import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Button,
  Icon,
  Input
} from 'semantic-ui-react'

const CardDrugDiseaseISegmentResultUX = (props: any) => {
    return(
      <div
        id="CardDrugDiseaseISegmentResultUX-div-0"
        style={{padding: "15px"}}>
        <div
          className="ui form"
          id="CardDrugDiseaseISegmentResultUX-div-1">
          
          <FormGroup
            id="CardDrugDiseaseISegmentResultUX-FormGroup-3"
            inline={true}>
            <div
              className="field"
              id="CardDrugDiseaseISegmentResultUX-div-4"
              style={{flex: 1}}>
              
            </div>
            <FormField
              id="CardDrugDiseaseISegmentResultUX-FormField-5"
              inline={true}>
              <div
                id="CardDrugDiseaseISegmentResultUX-div-31">
                {props.ButtonSave}
              </div>
            </FormField>
            <FormField
              id="CardDrugDiseaseISegmentResultUX-FormField-6"
              inline={true}>
              <Button
                color="red"
                id="CardDrugDiseaseISegmentResultUX-Button-8"
                onClick={props.onDelete}>
                {props.languageUX === "en" ? "Delete Segment" : "Delete Segment"}
              </Button>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardDrugDiseaseISegmentResultUX-div-2">
          {}
          <FormGroup
            id="CardDrugDiseaseISegmentResultUX-FormGroup-14"
            inline={true}>
            <FormField
              id="CardDrugDiseaseISegmentResultUX-FormField-15"
              inline={true}>
              <div
                id="CardDrugDiseaseISegmentResultUX-div-19"
                style={{display: "flex", justifyContent: "flex-end"}}>
                
                <label
                  id="CardDrugDiseaseISegmentResultUX-label-23"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Drug group type" : "ประเภทกลุ่มยา"}
                </label>
                <label
                  id="CardDrugDiseaseISegmentResultUX-label-24"
                  style={{color: "red"}}>
                  *
                </label>
                <label
                  id="CardDrugDiseaseISegmentResultUX-label-25"
                  style={{paddingLeft: "2.5px"}}>
                  :
                </label>
              </div>
            </FormField>
            <FormField
              id="CardDrugDiseaseISegmentResultUX-FormField-16"
              inline={true}
              width={5}>
              <Input
                id="CardDrugDiseaseISegmentResultUX-Input-29"
                readOnly={true}
                value={props.drugType || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugDiseaseISegmentResultUX-FormField-17"
              inline={true}>
              <div
                id="CardDrugDiseaseISegmentResultUX-div-20"
                style={{display: "flex", justifyContent: "flex-end"}}>
                
                <label
                  id="CardDrugDiseaseISegmentResultUX-label-26"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Drug name/drug group" : "ชื่อยา/กลุ่มยา"}
                </label>
                <label
                  id="CardDrugDiseaseISegmentResultUX-label-27"
                  style={{color: "red"}}>
                  *
                </label>
                <label
                  id="CardDrugDiseaseISegmentResultUX-label-28"
                  style={{paddingLeft: "2.5px"}}>
                  :
                </label>
              </div>
            </FormField>
            <FormField
              id="CardDrugDiseaseISegmentResultUX-FormField-18"
              inline={true}
              width={5}>
              <Input
                id="CardDrugDiseaseISegmentResultUX-Input-30"
                value={props.drugName || ""}>
              </Input>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDrugDiseaseISegmentResultUX-div-9">
          
          <Button
            color="blue"
            id="CardDrugDiseaseISegmentResultUX-Button-10"
            onClick={props.onAddSegmentResult}
            style={{marginBottom: "1rem"}}>
            
            <Icon
              id="CardDrugDiseaseISegmentResultUX-Icon-11"
              name="plus circle">
            </Icon>
            <label
              id="CardDrugDiseaseISegmentResultUX-label-12">
              {props.languageUX === "en" ? "Drug-Disease Interaction" : "ปฏิกิริยาระหว่างยาและโรค"}
            </label>
          </Button>
        </div>
        <div
          id="CardDrugDiseaseISegmentResultUX-div-13">
          {props.SubSegmentList}
        </div>
      </div>
    )
}

CardDrugDiseaseISegmentResultUX.displayName = "CardDrugDiseaseISegmentResultUX";
export default React.memo(CardDrugDiseaseISegmentResultUX)

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-2"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "field"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Delete Segment",
          "valueEN": "Delete Segment"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-Button-8"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDelete"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-Button-10"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddSegmentResult"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1rem\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Icon",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-Icon-11"
        },
        "name": {
          "type": "value",
          "value": "plus circle"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "ปฏิกิริยาระหว่างยาและโรค",
          "valueEN": "Drug-Disease Interaction"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-label-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SubSegmentList"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormGroup-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormField-15"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทกลุ่มยา",
          "valueEN": "Drug group type"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ":"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"2.5px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อยา/กลุ่มยา",
          "valueEN": "Drug name/drug group"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-label-26"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-label-27"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ":"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"2.5px\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Input",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-Input-29"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.drugType || \"\""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Input",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-Input-30"
        },
        "value": {
          "type": "code",
          "value": "props.drugName || \"\""
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSave"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDiseaseISegmentResultUX-div-31"
        }
      },
      "seq": 31,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": true,
  "name": "CardDrugDiseaseISegmentResultUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 65
}

*********************************************************************************** */
